import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default Route.extend({
  abilities: service(),

  beforeModel(transition) {
    if (this.abilities.noAbility('admin_view_users_and_funds')) {
      transition.abort();
    }
  },
});
